
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agreements/kvkk-policy",
      function () {
        return require("private-next-pages/agreements/kvkk-policy.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agreements/kvkk-policy"])
      });
    }
  